/**
 * @generated SignedSource<<e32efa3d3aa8342911345c9ac0bf08de>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FulfillBookingFlowFragment$data = {
  readonly bookingId: string;
  readonly status: string;
  readonly startDate: string;
  readonly endDate: string;
  readonly paymentMethod: string;
  readonly surveyStatus: string;
  readonly contract: {
    readonly __typename: string;
    readonly careReceiver: {
      readonly name: {
        readonly firstName: string;
        readonly lastName: string;
      };
    };
  };
  readonly " $fragmentType": "FulfillBookingFlowFragment";
};
export type FulfillBookingFlowFragment$key = {
  readonly " $data"?: FulfillBookingFlowFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"FulfillBookingFlowFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FulfillBookingFlowFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "bookingId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "paymentMethod",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "surveyStatus",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Contract",
      "kind": "LinkedField",
      "name": "contract",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "CareReceiver",
          "kind": "LinkedField",
          "name": "careReceiver",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Name",
              "kind": "LinkedField",
              "name": "name",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "firstName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "lastName",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Booking",
  "abstractKey": null
};

(node as any).hash = "d51d668b6915e78290b911f4a95a316e";

export default node;
